// CLASSES
import AppConfig from "@classes/AppConfig";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields, validFields} = state;

    for (const name in validFields)
    {
        if (validFields[name] === false)
        {
            return false;
        }
    }

    if ((!state.isCompany && !isOptionsListChecked(fields.radio_kyc_updt_sek5.options)) ||
        !isOptionsListChecked(fields.radio_kyc_updt_invgoals.options) ||
        !isOptionsListChecked(fields.radio_kyc_updt_risktaking.options) ||
        !isOptionsListChecked(fields.radio_kyc_updt_invhorizon.options) ||
        !isOptionsListChecked(fields.radio_hallbarhet_has_preferences.options))
    {
        return false;
    }

    if (fields.radio_kyc_updt_sek5.options[1].checked &&
        fields.customer_situation_changed_description.length <= 0)
    {
        return false;
    }

    if (fields.radio_kyc_updt_invgoals.options[1].checked &&
        fields.customer_goals_changed_description.length <= 0)
    {
        return false;
    }

    if (fields.radio_kyc_updt_risktaking.options[1].checked &&
        fields.customer_risktaking_changed_description.length <= 0)
    {
        return false;
    }

    if (fields.radio_kyc_updt_invhorizon.options[1].checked &&
        fields.customer_invhorizon_changed_description.length <= 0)
    {
        return false;
    }

    if (fields.radio_hallbarhet_has_preferences.options[1].checked)
    {
        if (!(fields.checkbox_hallbarhet_852 === "yes" ||
            fields.checkbox_hallbarhet_2088 === "yes" ||
            fields.checkbox_hallbarhet_customer === "yes" ||
            fields.checkbox_hallbarhet_art6 === "yes"))
        {
            return false;
        }

        if (fields.checkbox_hallbarhet_852 === "yes" &&
            fields.customer_hallbarhet_852_minimum.length <= 0)
        {
            return false;
        }

        if (fields.checkbox_hallbarhet_2088 === "yes" &&
            fields.customer_hallbarhet_2088_text.length <= 0)
        {
            return false;
        }

        if (fields.checkbox_hallbarhet_art6 === "yes" &&
            fields.customer_hallbarhet_art6_description.length <= 0)
        {
            return false;
        }
    }

    return true;
}

function isOptionsListChecked(list)
{
    for (let i = 0; i < list.length; i++)
    {
        if (list[i].checked)
        {
            return true;
        }
    }

    return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Kyc/KycChanges.fulfillment.js